var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.meetings),function(meeting){return _c('meeting',{key:meeting.id,attrs:{"meeting":meeting,"board":_vm.board}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }